import axios from 'axios';
import { TOKEN, USERNAME, IDUSUARIO } from '../constants';

const ENTREGAS_URL = process.env.REACT_APP_SID_ENTREGAS;

export default function(id, request) {
  const tipoCorreo = '2';
  const config = {
    params: {
      codigo: id,
    },
    headers: {
      codUsuario: USERNAME,
      idUsuario: IDUSUARIO,
      token: TOKEN,
    },
  };
  const data = {
    ...request,
    tipoCorreo,
  };

  return axios.put(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones/${id}/anulacion`, data, config);
}



// WEBPACK FOOTER //
// ./src/utils/postEntregasRechazarProg.js